import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from '../common';
import { IProperty } from '../models/i-property';
import { ApiResponse } from '../models/responses';

@Injectable({
  providedIn: 'root'
})
export class PropertyService {

  constructor(private http: HttpClient) { }

  GetLastPropertiesByCard(card: string): Observable<ApiResponse<IProperty[]>> {
    return this.http.get<ApiResponse<IProperty[]>>(
      `${Constants.API_URL}api/Property/GetLastPropertiesByCard?Card=${card}`)
  }

  GetPropertiesByCard(card: string): Observable<ApiResponse<IProperty[]>> {
    return this.http.get<ApiResponse<IProperty[]>>(
      `${Constants.API_URL}api/Property/GetPropertiesByCard?Card=${card}`)
  }
}
